import { Router, RouterModule } from "@angular/router";
import { Component } from "@angular/core";
import { CoreService } from "../../services/coreService";
import { CommonModule } from "@angular/common";
import { AddParkingPlaceComponent } from "../../components/add-parking-place/add-parking-place.component";

declare let toastr: any;

@Component({
  selector: "app-new-parking-place",
  templateUrl: "./new-parking-place.component.html",
  styleUrls: ["./new-parking-place.component.css"],
  providers: [CoreService],
  standalone: true,
  imports: [CommonModule, RouterModule, AddParkingPlaceComponent],
})
export class NewParkingPlaceComponent {
  constructor(
    private coreService: CoreService,
    private router: Router,
  ) {}

  saveParkingPlace(form) {
    this.coreService
      .SaveParkingPlace(form)
      .then((result) => {
        // this.iLoader = false;
        // this.router.navigate(['supplier/thankyou']);
        toastr.success("", "Parking place added successfully..", {
          timeOut: 2000,
        });
        this.router.navigateByUrl("/user/parkingplaces/" + result.data.id);
      })
      .catch((result) => {
        // this.iLoader = false;
        toastr.error("", "error registering you this time..", {
          timeOut: 2000,
        });
      });
  }
}
